import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import ItemCard from '../components/ItemCard';

const Search = () => {
  const { text } = useParams();

  const [searchNotFound, setSearchNotFound] = useState(false);

  useEffect(() => {
    console.log(text);
  }, [text]);

  return (
    <>
      {searchNotFound && (
        <Typography variant='h6' className='normal-font' align='center'>
          Your search <span style={{ color: 'orange' }}>'{text}'</span> did not match any products
        </Typography>
      )}

      <Typography align='center' mt={1}>
        Search result for: {text}
      </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ItemCard />
        </Grid>
      </Grid>
    </>
  );
};

export default Search;
